"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('TextInput'), (0, recompose_1.defaultProps)({ type: 'text', disabled: false, editable: true }), (0, recompose_1.withState)('isFocused', 'onFocusChange', false), recompose_1.pure);
exports.TextInput = enhance(function (_a) {
    var icon = _a.icon, iconRight = _a.iconRight, className = _a.className, type = _a.type, isFocused = _a.isFocused, disabled = _a.disabled, onFocusChange = _a.onFocusChange, notification = _a.notification, editable = _a.editable, autoFocus = _a.autoFocus, props = __rest(_a, ["icon", "iconRight", "className", "type", "isFocused", "disabled", "onFocusChange", "notification", "editable", "autoFocus"]);
    return (React.createElement("div", { className: classNames('sok-text-input', className, isFocused ? 'focused' : '', disabled ? 'disabled' : '', notification ? 'notification' : '') },
        React.Children.map(icon, function (child, id) {
            if (typeof child === 'object') {
                return React.cloneElement(child, { key: "left-icon-".concat(id) });
            }
            else {
                return React.createElement("span", { key: "left-icon-".concat(id) }, child);
            }
        }),
        editable &&
            (function () {
                if (type === 'textarea') {
                    return (React.createElement("textarea", __assign({ key: 'textarea-field' }, props, { onFocus: function (e) {
                            onFocusChange(true);
                            props.onFocus && props.onFocus(e);
                        }, onBlur: function (e) {
                            onFocusChange(false);
                            props.onBlur && props.onBlur(e);
                        }, disabled: disabled, autoFocus: autoFocus })));
                }
                return (React.createElement("input", __assign({ key: 'input-field' }, props, { onFocus: function (e) {
                        onFocusChange(true);
                        props.onFocus && props.onFocus(e);
                    }, onBlur: function (e) {
                        onFocusChange(false);
                        props.onBlur && props.onBlur(e);
                    }, disabled: disabled, type: type, autoFocus: autoFocus })));
            })(),
        !editable && (React.createElement("span", __assign({ key: 'input-field' }, props, { className: classNames('value', type) }),
            props.value || props.defaultValue || '',
            React.createElement("input", null))),
        React.Children.map(iconRight, function (child, id) {
            if (typeof child === 'object') {
                return React.cloneElement(child, { key: "left-icon-".concat(id) });
            }
            else {
                return React.createElement("span", null, child);
            }
        })));
});
//# sourceMappingURL=index.js.map